import React from 'react';
import { IColumn } from '..';
import { contextMenuConfig } from '../config';
import { IDataRowGroup } from '../models/IDataRowGroup';
import { IInternalColumn } from '../models/IInternalColumn';
import { ScrollingDirection } from '../types/ScrollingDirection';
import { SortType } from '../types/SortType';
import { groupDataSourceBy, ReOrderItem } from '../utils';
import { sortData } from '../utils/ArrayUtils';
import { filterByColumnName } from '../utils/DataGroupingUtils';
import GridHeader from './header/GridHeader';
import { ITVoSimpleGridProps } from './ITVoSimpleGridProps';
import { ITVoSimpleGridState } from './ITVoSimpleGridState';
import GridRow from './row/GridRow';
import GridRowGroup from './row/GridRowGroup';
import styles from './TVoSimpleGrid.module.scss';

export default class TvoSimpleGrid extends React.Component<
  ITVoSimpleGridProps,
  ITVoSimpleGridState
> {
  private _borderColor = '#cccdce';
  private _hoverColor = '#a7a7a7';
  private _scrollElement: any | null;
  private _isMounted: boolean = false;
  private _currentGroupByColumn: string = '';
  private scrollingDirection = ScrollingDirection.down;
  private isScrolling: boolean = false;
  constructor(props: ITVoSimpleGridProps) {
    super(props);
    try {
      //initilize state
      this.initializeColumn();

      this.dropDownClick = this.dropDownClick.bind(this);
      this.onScrollToBottom = this.onScrollToBottom.bind(this);
    } catch (error) {
      //console.log('constructor', error);
    }
  }

  private getDataSourceGrouping(
    columnFieldName: string,
    internalColumns: IInternalColumn[],
    dataSource: any[]
  ) {
    let dataSourceArray: IDataRowGroup[] = [];
    try {
      var dataSourceGroup;
      if (columnFieldName !== undefined && columnFieldName !== '') {
        const groupByField = groupDataSourceBy(columnFieldName);
        dataSourceGroup = groupByField(dataSource);
        var columnName = filterByColumnName(columnFieldName, internalColumns);
        for (var groupName in dataSourceGroup) {
          dataSourceArray.push({
            groupName: groupName,
            groupByColumnName: columnName,
            groupData: dataSourceGroup[groupName]
          });
        }
        return dataSourceArray;
      }
    } catch (error) {}
    return dataSourceArray;
  }

  /**
   * initialize column
   */
  private initializeColumn() {
    let internalColumn: IInternalColumn[] = this.props.columnDefs
      .columns as IInternalColumn[];
    var groupByColumnFieldName =
      this.props.columnDefs.groupByColumnFieldName !== undefined
        ? this.props.columnDefs.groupByColumnFieldName
        : '';
    for (var i = 0; i < internalColumn.length; i++) {
      internalColumn[i].isArrowUp = false;
      internalColumn[i].sortDirection = SortType.none;
      if (
        internalColumn[i].fieldName.toLowerCase() ===
        this.props.columnDefs.groupByColumnFieldName?.toLocaleLowerCase()
      ) {
        internalColumn[i].isGrouping = true;
      } else internalColumn[i].isGrouping = false;
    }
    var dataSource =
      this.props.dataSource === undefined ? [] : this.props.dataSource;
    this.state = {
      columnDefs: this.props.columnDefs,
      dataSource: dataSource,
      columns: internalColumn,
      dataSourceGroup: this.getDataSourceGrouping(
        groupByColumnFieldName,
        internalColumn,
        dataSource
      ),
      isRendered: true,
      disableScroll:
        this.props.disableGridScroll !== undefined
          ? this.props.disableGridScroll
          : false,
      groupByColumnName:
        this.props.columnDefs.groupByColumnFieldName !== undefined
          ? this.props.columnDefs.groupByColumnFieldName
          : ''
    };
  }

  private closeContext() {
    this.dropDownClick('none');
  }

  public componentDidUpdate(
    prevProp: ITVoSimpleGridProps,
    prevState: ITVoSimpleGridState
  ) {
    try {
      if (prevProp.columnDefs !== this.props.columnDefs) {
        this.setColumns();
        if (this._scrollElement) {
          this._scrollElement.scrollTo(0, 0);
        }
      }
      if (prevProp.dataSource !== this.props.dataSource) {
        var dataSource =
          this.props.dataSource === undefined ? [] : this.props.dataSource;
        this.setState({
          dataSource: dataSource,
          dataSourceGroup: this.getDataSourceGrouping(
            this.state.groupByColumnName,
            this.state.columns,
            dataSource
          )
        });
        //after data source update set this to false to wait rendered
        this.setState({ isRendered: false });
      }

      if (
        prevProp.dataSource === this.props.dataSource &&
        !this.state.isRendered
      ) {
        //after rendered set this true
        this.setState({ isRendered: true });
      }

      if (
        prevProp.columnDefs.dataSourceName !==
          this.props.columnDefs.dataSourceName &&
        !this.state.isRendered
      ) {
        this.makeTableDraggable();
      }

      if (
        this.state.dataSource !== undefined &&
        prevState.dataSource !== undefined
      ) {
        if (prevState.dataSource.length < this.state.dataSource.length) {
          var self = this;
          setTimeout(() => {
            self.updateSorting();
          }, 500);
        }
      }

      if (
        prevProp.dataSource !== undefined &&
        this.props.dataSource !== undefined &&
        prevProp.dataSource.length < this.props.dataSource.length
      ) {
        this._scrollElement.scrollTop = Math.ceil(
          this._scrollElement.scrollTop * 0.8
        );

        //console.log('prev', prevProp.dataSource.length);
        // console.log('prev', this.props.dataSource.length);
      }
    } catch (error) {
      //console.log('did update', error);
    }
  }

  private setColumns() {
    let internalColumn: IInternalColumn[] = this.props.columnDefs
      .columns as IInternalColumn[];

    for (var i = 0; i < internalColumn.length; i++) {
      if (internalColumn[i].isArrowUp === undefined)
        internalColumn[i].isArrowUp = false; //set it to false since it does not exist
    }
    this.setState({
      columnDefs: this.props.columnDefs,
      columns: internalColumn
    });
  }

  private handleScrollElement() {
    try {
      //check if disable scrolling
      if (
        this.props.disableGridScroll !== undefined &&
        this.props.disableGridScroll
      ) {
        //check to see if the user passing scroll element
        if (
          this.props.scrollElement !== undefined &&
          this.props.scrollElement !== null
        ) {
          this._scrollElement = this.props.scrollElement;
        } else {
          this._scrollElement = window; //body scrolling
        }
      } else this._scrollElement = document.getElementById('tvo-simple-grid'); //grid scrolling

      if (this._scrollElement !== null) {
        this._scrollElement.addEventListener('scroll', this.onScrollToBottom);
      }
    } catch (error) {}
  }

  public componentDidMount() {
    this._isMounted = true;
    this.handleScrollElement();
    this.makeTableDraggable();
    document.addEventListener('click', this.outSideClickHandler, false);
    window.addEventListener('mousewheel', this.onScrollingDirection, false);
  }

  public componentWillUnmount() {
    try {
      this._isMounted = false;
      //remove all the events
      document.removeEventListener('click', this.outSideClickHandler);
      document.removeEventListener('mousewheel', this.onScrollingDirection);
    } catch (error) {}
  }

  private makeTableDraggable() {
    var table = document.getElementById('table-grid');
    if (table) this.resizableGrid(table);
  }

  private resizableGrid(table: any) {
    var row = table.getElementsByTagName('tr')[0],
      cols = row ? row.children : undefined;
    if (!cols) return;
    table.style.overflow = 'scroll';
    var tableHeight = table.tHead.offsetHeight;
    //var tableHeight = 40;
    var self = this;
    for (var i = 0; i < cols.length; i++) {
      var lastChild = i + 1 === cols.length;
      //create div and notify if it is not last child
      var div = self.createDiv(tableHeight, lastChild);
      var thEle = cols[i];
      //remove any extra div
      if (thEle.childNodes.length > 0) {
        var elementLength = cols[i].childNodes.length;
        for (var j = 0; j < elementLength; j++) {
          var cNode = thEle.childNodes[j];
          if (cNode && cNode.className === '') thEle.removeChild(cNode);
        }
      }
      cols[i].appendChild(div);
      this.setListeners(div, lastChild);
    }
  }
  private setListeners(div: any, lastChild: boolean) {
    let pageX: any,
      curCol: any,
      nxtCol: any,
      curColWidth: any,
      nxtColWidth: any;

    var self = this;
    div.addEventListener('mousedown', function (e: any) {
      if (lastChild) return;
      curCol = e.target.parentElement;
      nxtCol = curCol.nextElementSibling;
      pageX = e.pageX;
      var padding = self.paddingDiff(curCol);
      curColWidth = curCol.offsetWidth - padding;
      if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
    });

    div.addEventListener('mouseover', function (e: any) {
      if (!lastChild)
        e.target.style.borderRight = '2px solid ' + self._hoverColor;
    });

    div.addEventListener('mouseout', function (e: any) {
      if (!lastChild)
        e.target.style.borderRight = 'solid 1px ' + self._borderColor;
    });

    document.addEventListener('mousemove', function (e) {
      if (lastChild) return;
      if (curCol) {
        var diffX = e.pageX - pageX;

        if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + 'px';

        curCol.style.width = curColWidth + diffX + 'px';
      }
    });
    document.addEventListener('mouseup', function (e: any) {
      if (lastChild) return;
      if (e) {
      }
      curCol = undefined;
      nxtCol = undefined;
      pageX = undefined;
      nxtColWidth = undefined;
      curColWidth = undefined;
    });
  }

  private createDiv(height: any, lastChild: boolean) {
    let div: HTMLDivElement = document.createElement('div');
    var pxHeight = height + 'px';
    //comment code below out since using css
    // var borderRight = !lastChild
    //   ? 'border-right:solid 1px ' + this._borderColor
    //   : 'border-right:none';
    // div.setAttribute(
    //   'style',
    //   borderRight +
    //     ';top:0;right:0;width:5px;position:absolute;cursor:col-resize;userSelect:none;height:' +
    //     pxHeight
    // );
    if (!lastChild) {
      div.setAttribute('class', `${styles.borderRight}`);
      div.setAttribute('style', 'height:' + pxHeight);
    }

    return div;
  }

  private paddingDiff(col: any) {
    if (this.getStyleVal(col, 'box-sizing') === 'border-box') {
      return 0;
    }

    var padLeft = this.getStyleVal(col, 'padding-left');
    var padRight = this.getStyleVal(col, 'padding-right');
    return parseInt(padLeft) + parseInt(padRight);
  }

  private getStyleVal(elm: any, css: any) {
    return window.getComputedStyle(elm, null).getPropertyValue(css);
  }

  private _onSort = (columnKey: string, sortKey: string, value: string) => {
    this.closeContext();
    let sortType: SortType = SortType.up;
    let dataSource =
      this.state.dataSource !== undefined ? [...this.state.dataSource] : [];

    if (value === contextMenuConfig.sortDown) {
      sortType = SortType.down;
    }
    let sortedDataSource: any[] = sortData(dataSource, sortType, sortKey);
    //update state sorting icon
    let internalCols: IInternalColumn[] = this.getUpdatedIconOnSorting(
      columnKey,
      sortType
    );
    this.setState({
      dataSource: sortedDataSource,
      columns: internalCols,
      dataSourceGroup: this.getDataSourceGrouping(
        this.state.groupByColumnName,
        internalCols,
        sortedDataSource
      )
    });
  };

  private _onGrouping = (
    columnKey: string,
    columnFieldName: string,
    isGrouping: boolean
  ) => {
    this.closeContext();
    let internalCols: IInternalColumn[] = this.state.columns;
    let sortKey: string = '';
    let sortDirection: SortType = SortType.none;
    for (var i = 0; i < internalCols.length; i++) {
      if (internalCols[i].key === columnKey) {
        internalCols[i].isGrouping = isGrouping;
      } else internalCols[i].isGrouping = false;

      //check for current column sorting
      if (internalCols[i].sortDirection !== SortType.none) {
        sortKey = internalCols[i].fieldName;
        sortDirection = internalCols[i].sortDirection;
      }
    }
    let dataSource =
      this.state.dataSource !== undefined ? [...this.state.dataSource] : [];
    let sortedDataSource: any[] = sortData(dataSource, sortDirection, sortKey);
    //update state
    this.setState({
      columns: internalCols,
      dataSource: sortedDataSource,
      groupByColumnName: isGrouping ? columnFieldName : '',
      dataSourceGroup: isGrouping
        ? this.getDataSourceGrouping(
            columnFieldName,
            internalCols,
            sortedDataSource
          )
        : []
    });
  };

  private updateSorting() {
    let tempCols: IInternalColumn[] = this.state.columns;
    for (var i = 0; i < tempCols.length; i++) {
      if (tempCols[i].sortDirection === SortType.down)
        this._onSort(
          tempCols[i].key,
          tempCols[i].fieldName,
          contextMenuConfig.sortDown
        );
      if (tempCols[i].sortDirection === SortType.up)
        this._onSort(
          tempCols[i].key,
          tempCols[i].fieldName,
          contextMenuConfig.sortUp
        );
    }
  }

  private getUpdatedIconOnSorting(
    columnKey: string,
    sortType: SortType
  ): IInternalColumn[] {
    let internalCols: IInternalColumn[] = this.state.columns;

    for (var i = 0; i < internalCols.length; i++) {
      if (internalCols[i].key === columnKey) {
        internalCols[i].sortDirection = sortType;
      } else internalCols[i].sortDirection = SortType.none;
    }
    return internalCols;
  }

  private outSideContextMenuClickHandler() {
    var self = this;

    document.addEventListener(
      'click',
      (evt) => {
        var parentElement = document.getElementById('column-header-label');
        var targetElement: any = evt.target;
        var contextElement = document.getElementById('contextMenu');
        //context element not exist then return
        if (!contextElement) {
          return;
        }
        do {
          try {
            if (targetElement === undefined || targetElement == null) return;
            if (
              targetElement.className !== undefined &&
              parentElement?.className === targetElement.className
            ) {
              return;
            }
            if (
              targetElement.className !== undefined &&
              (targetElement.className
                .toString()
                .toLowerCase()
                .indexOf('columncontextmenu') > -1 ||
                targetElement.className
                  .toString()
                  .toLowerCase()
                  .indexOf('column-header-label') > -1)
            ) {
              return;
            }
            if (
              targetElement.id !== undefined &&
              (targetElement.id === 'arrow-down' ||
                targetElement.id === 'arrow-up')
            ) {
              return;
            }
            targetElement = targetElement.parentNode;
          } catch (error) {
            return;
          }
        } while (targetElement);

        self.dropDownClick('none');
      },
      false
    );
  }

  private onScrollingDirection = (event: any) => {
    try {
      event.stopPropagation();
      this.scrollingDirection =
        event.wheelDelta < 0 ? ScrollingDirection.down : ScrollingDirection.up;
    } catch (error) {}
  };

  private outSideClickHandler = (evt: any) => {
    var parentElement = document.getElementById('column-header-label');
    var targetElement: any = evt.target;
    var contextElement = document.getElementById('contextMenu');
    //context element not exist then return
    if (!contextElement) {
      return;
    }
    do {
      try {
        if (targetElement === undefined || targetElement == null) return;
        if (
          targetElement.className !== undefined &&
          parentElement?.className === targetElement.className
        ) {
          return;
        }
        if (
          targetElement.className !== undefined &&
          (targetElement.className
            .toString()
            .toLowerCase()
            .indexOf('columncontextmenu') > -1 ||
            targetElement.className
              .toString()
              .toLowerCase()
              .indexOf('column-header-label') > -1)
        ) {
          return;
        }
        if (
          targetElement.id !== undefined &&
          (targetElement.id === 'arrow-down' || targetElement.id === 'arrow-up')
        ) {
          return;
        }
        targetElement = targetElement.parentNode;
      } catch (error) {
        return;
      }
    } while (targetElement);

    this.dropDownClick('none');
  };

  private dropDownClick = (columnKey: string) => {
    if (!this._isMounted) return;

    //set state for dropdown
    let tempCols: IInternalColumn[] = this.state.columns;

    for (var i = 0; i < tempCols.length; i++) {
      if (tempCols[i].key !== columnKey && tempCols[i].isArrowUp) {
        tempCols[i].isArrowUp = false;
      }
      if (tempCols[i].key === columnKey) {
        tempCols[i].isArrowUp = !tempCols[i].isArrowUp;
      }
    }
    try {
      this.setState({ columns: tempCols });
    } catch (error) {
      // console.log('dropt down', error);
    }
  };

  private onScrollToBottom(event: any) {
    try {
      event.preventDefault();
      let isBottom: boolean = false;
      var self = this;
      var scrollTop = event.target.scrollTop;
      var offsetHeight = event.target.offsetHeight;
      if (this.state.disableScroll && this.props.scrollElement === undefined) {
        //scroll the body
        var totalPageHeight = document.body.scrollHeight;
        var scrollPoint = Math.ceil(window.scrollY + window.innerHeight);
        isBottom = scrollPoint >= totalPageHeight;
      } else {
        //scroll the grid
        isBottom =
          Math.ceil(event.target.offsetHeight + event.target.scrollTop) >=
          event.target.scrollHeight;
      }
      //return on wheel scrolling up
      if (this.scrollingDirection === ScrollingDirection.up) return;

      if (
        isBottom &&
        !this.isScrolling &&
        this.props.onScrollToBottom !== undefined
      ) {
        this.isScrolling = true; //prevent continously scrolling
        setTimeout(() => {
          if (self.props.onScrollToBottom !== undefined) {
            //this._scrollElement.scrollTop = Math.ceil(scrollTop * 0.8);

            //console.log(this.scrollingDirection);
            this.isScrolling = false;
            self.props.onScrollToBottom(this.props.columnDefs.dataSourceName);
          }
        }, 200);
      }
    } catch (error) {}
  }

  private _onContextMenuClick = (
    dataSourceName: string,
    column: IColumn,
    contextValue: string,
    contextLabel: string
  ) => {
    this.closeContext();
    if (this.props.onContextMenuClick !== undefined)
      this.props.onContextMenuClick(
        dataSourceName,
        column.key,
        column.fieldName,
        contextValue,
        contextLabel
      );
  };

  public render() {
    var disableScroll =
      this.props.disableGridScroll !== undefined
        ? this.props.disableGridScroll
        : false;
    const wrapperStyle = {
      height:
        this.props.gridHeight !== undefined
          ? this.props.gridHeight
          : disableScroll
          ? 'auto'
          : '500',
      background:
        this.props.gridBackgroundColor !== undefined
          ? this.props.gridBackgroundColor
          : 'auto',
      OverflowY: disableScroll ? 'hidden' : 'auto'
    };

    const tableStyle = {
      width: this.props.gridWidth !== undefined ? this.props.gridWidth : '100%'
    };
    return (
      <div
        style={wrapperStyle}
        className={
          !disableScroll
            ? styles['tvo-simple-grid-overflow'] +
              ' ' +
              styles['tvo-simple-grid']
            : styles['tvo-simple-grid']
        }
        id='tvo-simple-grid'
      >
        <table id='table-grid' style={tableStyle}>
          <thead>
            <tr>
              {this.state.columns.map((c: IInternalColumn, i) => (
                <th
                  style={{
                    color:
                      this.props.headerColor !== undefined
                        ? this.props.headerColor
                        : 'auto',
                    width: c.columnWidth !== undefined ? c.columnWidth : 'auto',
                    background:
                      this.props.headerBackgroundColor !== undefined
                        ? this.props.headerBackgroundColor
                        : 'auto'
                  }}
                  key={i}
                >
                  <GridHeader
                    key={i}
                    column={c}
                    dataSourceName={this.state.columnDefs.dataSourceName}
                    dropDownClick={this.dropDownClick}
                    onSorting={this._onSort}
                    onGrouping={this._onGrouping}
                    onHeaderItemRender={this.props.onHeaderItemRender}
                    onContextMenuClick={this._onContextMenuClick}
                    onContextMenuRender={this.props.onContextMenuRender}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.state.dataSource !== undefined &&
              this.state.groupByColumnName === '' &&
              this.state.dataSource.map((item: any, index: any) => (
                <GridRow
                  key={index}
                  dataItem={item}
                  columnDefs={this.props.columnDefs}
                  onRowItemRender={this.props.onRowItemRender}
                  onRowItemClick={this.props.onRowItemClick}
                />
              ))}
            {this.state.dataSourceGroup.length > 0 &&
              this.state.groupByColumnName !== '' &&
              this.state.dataSourceGroup.map((item: any, index: any) => (
                <GridRowGroup
                  key={index}
                  dataItem={item}
                  columnDefs={this.props.columnDefs}
                  onRowItemRender={this.props.onRowItemRender}
                  onRowItemClick={this.props.onRowItemClick}
                  groupName={item.groupByColumnName + ': ' + item.groupName}
                  groupItems={item.groupData}
                />
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}
